import Timestampable from '@/models/Timestampable'
import { ImageInterface, ImageDocInterface, id } from '@/types/models'
import {
  db,
  auth,
  serverTimestamp,
  firestoreTimestampToDate,
  DocumentReference,
} from '@/firebase'
import store from '@/store'
import Plant from '@/models/Plant'
// import {  } from '@/types/store';

// import { getFirebaseStorageUrl } from '@/firebase/storage'
// import { getStoragePathSize } from '@/helpers/paths'
import Garden from '@/models/Garden'
import Harvest from '@/models/Harvest'
import Imagable from '@/models/Imagable'
import LogItem from './LogItem'
import {
  DocumentData,
  QueryDocumentSnapshot,
  SnapshotOptions,
} from 'firebase/firestore'

// const IMAGE_SIZE_SMALL = 40
// const IMAGE_SIZE_MEDIUM = 200
// const IMGAE_SIZE_LARGE = 2560

// export interface ImageUrl {
//   orig: string;
//   s: string;
//   m: string;
//   l: string;
// }

type RefItem = Plant | Harvest | LogItem
interface ImageRefInterface<T = RefItem> {
  ref: string
  item: T
}

class ImageRef<T = RefItem> {
  ref: string
  item: T

  constructor(input: ImageRefInterface<T>) {
    this.ref = input.ref
    this.item = input.item
  }

  get type(): string {
    return this.ref.split('/').slice(-2)[0]
  }

  static createFromRef(ref: string, storeFindName = 'find'): ImageRef {
    const refArray = ref.split('/')
    const colArray = refArray.filter((element, index) => index % 2 === 0)
    const valArray = refArray.filter((element, index) => (index + 1) % 2 === 0)

    // const item = store.getters[ [...refArray.slice(0, -1), storeFindName].join('/') ](refArray.slice(-1)[0])
    // const item = store.getters[ [...colArray, storeFindName].join('/') ](...valArray)

    const getterFn = [...colArray, storeFindName].join('/')
    const getterVal = valArray.slice(-1)[0]
    // console.log(refArray, colArray, valArray, getterFn, getterVal)

    const item = store.getters[getterFn](getterVal)

    return new ImageRef({ ref, item })
  }
}

export default class Image extends Imagable implements Timestampable {
  createdAt?: Date
  createdBy?: string
  updatedAt?: Date
  updatedBy?: string

  isNew = false

  id: id
  gardenId: id

  // fullpath: string;
  // bucket: string;
  // token: string;
  // width: number;
  // height: number;
  // exif?: ExifInterface;
  // takenAt?: Date;

  note?: string | null

  // batchId?: string | null;
  // plantIds: id[];
  refs: string[]

  collections() {
    return {}
  }

  constructor(data: ImageInterface) {
    super(data)

    this.createdAt = data.createdAt
    this.createdBy = data.createdBy
    this.updatedAt = data.updatedAt
    this.updatedBy = data.updatedBy

    this.id = data.id
    this.gardenId = data.gardenId

    // this.fullpath = data.fullpath
    // this.bucket = data.bucket
    // this.token = data.token
    // this.width = data.width
    // this.height = data.height
    // this.exif = data.exif
    // this.takenAt = data.takenAt

    this.note = data.note
    this.refs = data.refs

    this.isNew = data.isNew || false
  }

  get takenAt(): Date | undefined {
    return this._takenAt || this.createdAt || this.updatedAt
  }

  set takenAt(val: Date | undefined) {
    this._takenAt = val
  }

  get garden(): Garden {
    return store.getters['gardens/find'](this.gardenId)
  }

  // get allSizeUrls(): string[] {
  //   return [
  //     this.url,
  //     this.largeUrl,
  //     this.mediumUrl,
  //     this.smallUrl
  //   ]
  // }

  // get aspectRatio(): number {
  //   return this.width / this.height
  // }

  // get url(): ImageUrl {
  //   return {
  //     orig: getFirebaseStorageUrl(this.bucket, this.fullpath, this.token),
  //     s: getFirebaseStorageUrl(this.bucket, this.fullpath, this.token, IMAGE_SIZE_SMALL),
  //     m: getFirebaseStorageUrl(this.bucket, this.fullpath, this.token, IMAGE_SIZE_MEDIUM),
  //     l: getFirebaseStorageUrl(this.bucket, this.fullpath, this.token, IMGAE_SIZE_LARGE),
  //   }
  // }

  // get smallUrl(): string {
  //   return getStorageUrlSize(this.url, IMAGE_SIZE_SMALL)
  // }

  // get mediumUrl(): string {
  //   return getStorageUrlSize(this.url, IMAGE_SIZE_MEDIUM)
  // }

  // get largeUrl(): string {
  //   return getStorageUrlSize(this.url, IMGAE_SIZE_LARGE)
  // }

  // get fullpaths(): ImageUrl {
  //   return {
  //     orig: this.fullpath,
  //     s: getStoragePathSize(this.fullpath, IMAGE_SIZE_SMALL),
  //     m: getStoragePathSize(this.fullpath, IMAGE_SIZE_MEDIUM),
  //     l: getStoragePathSize(this.fullpath, IMGAE_SIZE_LARGE),
  //   }
  // }

  // get allSizePaths(): string[] {
  //   return [
  //     this.fullpath,
  //     this.largeFullpath,
  //     this.mediumFullpath,
  //     this.smallFullpath,
  //   ]
  // }

  get refItems(): Array<ImageRef> {
    return this.refs.map((ref: string) => ImageRef.createFromRef(ref))
  }

  get plantIds(): id[] {
    // return this.refs
    //   .map((ref: string) => ref.split("/"))
    //   .filter(
    //     (refArr: string[]) =>
    //       refArr.length >= 4 &&
    //       refArr[0] === "gardens" &&
    //       refArr[2] === "plants"
    //   )
    //   .map((refArr: string[]) => refArr[3]);

    return this.plants.map((p) => p.id)
  }

  get plants(): Plant[] {
    // console.log('refs', this.refs)
    // console.log("refItems", this.refItems);
    // console.log('plantIds', this.plantIds)

    // return store.getters['gardens/plants/filter'](this.plantIds)

    return [
      ...new Set([
        // Plant
        ...this.refItems
          .filter((z): z is ImageRef<Plant> => z.type === 'plants')
          .map((z) => z.item),
        // Harvest
        ...this.refItems
          .filter((z): z is ImageRef<Harvest> => z.type === 'harvests')
          .map((z) => z.item.plant),
        // LogItem
        ...this.refItems
          .filter((z): z is ImageRef<LogItem> => z.type === 'log')
          .flatMap((z) => z.item.plants),
      ]),
    ]
  }

  static fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions,
    gardenId: id
  ): Image {
    const data = snapshot.data(options)

    const result: ImageInterface = {
      id: snapshot.id,
      gardenId: gardenId,

      fullpath: data.fullpath,
      width: data.width,
      height: data.height,
      bucket: data.bucket,
      token: data.token,
      takenAt: firestoreTimestampToDate(data.takenAt),
      exif: data.exif,

      note: data.note,
      refs: data.refs.map((r: DocumentReference) => r.path),

      createdBy: data.createdBy,
      createdAt: firestoreTimestampToDate(data.createdAt),
      updatedBy: data.updatedBy,
      updatedAt: firestoreTimestampToDate(data.updatedAt),

      isNew: false,
    }

    return new Image(result)
  }

  static firestoreConverter = (gardenId: id) => ({
    toFirestore(item: Image): DocumentData {
      const h: ImageDocInterface = {
        gardenId: gardenId,

        fullpath: item.fullpath,
        width: item.width,
        height: item.height,
        bucket: item.bucket,
        token: item.token || null,
        takenAt: item.takenAt || null,
        exif: item.exif || null,

        note: item.note || null,
        refs: item.refs.map((ref: string) => db.doc(ref)),
      }

      if (item.isNew) {
        h.createdBy = auth.currentUser()?.uid
        h.createdAt = serverTimestamp()
      } else {
        h.updatedBy = auth.currentUser()?.uid
        h.updatedAt = serverTimestamp()
      }

      return h
    },
    fromFirestore(
      snapshot: QueryDocumentSnapshot,
      options: SnapshotOptions
    ): Image {
      return Image.fromFirestore(snapshot, options, gardenId)
    },
  })
}
